export const data = [];
export const messages = {};



// WEBPACK FOOTER //
// ./src/assets/scripts/i18n/default.ts